/*
 * @fileOverView SearchPill component definition
 *
 * Acts as a simple text search field. For suggestions as the user types, see
 * the Search Pill Suggest component.
 */

import Vue from 'vue';

/**
 * [SearchPill Vue]
 * @type {class}
 */
Vue.component('searchpill-vue', {
  data: function() {
    return {
      value: ''
    }
  },

  methods: {
    /**
     * Handles the submission of the search form element.
     */
    handleSubmit: function (e) {
      this.submit();
    },

    /**
     * Resets the element to the default value.
     *
     * Exists to be used by parent elements, such as filters.
     */
    reset() {
      this.set('');
    },

    /**
     * Set the element to a specific value.
     *
     * Exists to be used by parent elements, such as filters.
     *
     * @param {String} value
     *   The value to set the element to.
     */
    set(value) {
      this.value = value;
      this.submit();
    },

    /**
     * Emits an event for parents that need to react, such as filters.
     */
    submit() {
      this.$emit('searchpill-submit', this.value, this.$el);
    }
  }
})
